/**
 * 统一维护 slot 数据
 * 具体插槽描述&截图查看知识库文档 https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/ZzIjzst2PP/alWv-lnFcGnJp0
 */

// slot type
export const SlotTypeMap = {
    Normal: 'Normal',
    List: 'List',
    Text: 'Text',
};

// slot action
export const SlotActionMap = {
    Add: 'Add',
    Replace: 'Replace',
    Delete: 'Delete',
};

// slot scope 插槽开放的模块划分
export const SlotScopeMap = {
    // 用户域全局设置
    UserSetting: 'UserSetting',
    // 用户域顶栏
    UserHeader: 'UserHeader',
    // 用户域首页
    UserHome: 'UserHome',
    // 用户域帮助按钮
    UserHelp: 'UserHelp',
    // 用户信息卡片
    UserInfoTip: 'UserInfoTip',
    // 用户域搜索落地页
    UserSearchPage: 'UserSearchPage',

    // 空间域我的部门
    SpaceDepartment: 'SpaceDepartment',
    // 空间域目录树
    SpaceRepo: 'SpaceRepo',
    // 空间域权限申请页
    SpacePermission: 'SpacePermission',
    // 空间域部门知识库首页
    SpaceDepartHome: 'SpaceDepartHome',
    // 空间域个人知识库首页
    SpacePersonalHome: 'SpacePersonalHome',
    // 空间域知识库设置
    SpaceSetting: 'SpaceSetting',
    // 空间域知识库Home
    SpaceKnowledgeHome: 'SpaceKnowledgeHome',
    // 空间域文档Home组件
    SpaceDocHome: 'SpaceDocHome',
    // 文档域编辑器相关
    DocumentEditor: 'DocumentEditor',
    // 文档域 操作栏
    DocumentHeader: 'DocumentHeader',
    // 文档域 知识本
    Book: 'Book',
    // 帮助按钮
    Help: 'Help',
    // 对外知识库相关
    ExternalRepo: 'ExternalRepo',
};

// slot position 插槽在每个模块里的具体位置
export const SlotPositionMap = {
    // 用户域
    UserSetting: {
        AllEntry: 'AllEntry', // 用户域全局设置 -  左侧入口
        NotifyMention: 'NotifyMention', // 用户域全局设置 - 太细节了，暂不开放
        NotifyApproval: 'NotifyApproval', // 用户域全局设置 - 太细节了，暂不开放
        NotifyOther: 'NotifyOther', // 用户域全局设置 - 太细节了，暂不开放
        Intelligent: 'Intelligent', // 用户域全局设置 - 已开放
    },
    UserHeader: {
        Search: 'Search', // 用户域顶栏 - 老的搜索框
        All: 'All', // 用户域顶栏 - 整块head
        Create: 'Create', // 用户域顶栏 - 新建按钮
        Message: 'Message', // 用户域顶栏 -消息通知
        Avatar: 'Avatar', // 用户域顶栏 - 头像
        AvatarSlot: 'AvatarSlot', // 用户域顶栏 - 头像内部的插槽（目前使用场景: 广场小红点）
        CreateMenu: 'CreateMenu', // 用户域顶栏 - 新建下拉菜单
        AvatarMenu: 'AvatarMenu', // 用户域顶栏 - 头像下拉菜单
    },
    UserHome: {
        SidebarBottom: 'SidebarBottom', // 用户域首页 - 右侧栏底部插槽
        hotList: 'hotList', // 用户域首页 - 热点知识榜
        highQualityList: 'highQualityList', // 用户域首页 - 高价值知识榜
        DocTypeFilter: 'DocTypeFilter', // 用户域首页 - 文档类型选择器
        AboutMe: 'AboutMe', // 用户域首页 - 我参与的
        NormalDropMenu: 'NormalDropMenu', // 知识库首页-文档类型筛选
        PersonalRepoSlot: 'PersonalRepoSlot', // 用户域顶栏 - 个人知识库内部插槽（目前使用场景: 广场小红点）
        LogoHome: 'LogoHome', // 首页logo
        LogoTop: 'LogoTop', // 顶栏左侧logo（非首页）
        SuperiorOrganization: 'SuperiorOrganization', // 用户域首页 - 上级组织
        PersonalReports: 'PersonalReports', // 我的主页 - 我的年度报告模块
        GiveCoin: 'GiveCoin', // 我的主页 - 去赠币
        CreateAndRead: 'CreateAndRead', // 我的主页 - 创作与阅读
    },
    UserHelp: {
        HelpIcon: 'HelpIcon', // 用户域帮助按钮 - 问号入口
        HelpMenu: 'HelpMenu', // 用户域帮助 - 下拉菜单
    },
    UserInfoTip: {
        RuliuIcon: 'RuliuIcon', // 用户信息卡片 - 如流按钮
        PersonalPageIcon: 'PersonalPageIcon', // 用户信息卡片 - 个人主页按钮
    },
    UserSearchPage: {
        SearchPageRight: 'SearchPageRight', // 搜索落地页 - 右侧
        SearchTypeOptions: 'SearchTypeOptions', // 搜索落地页 - 结果类型
        RelatedSearch: 'RelatedSearch', // 搜索落地页 - 相关搜索
        TipBox: 'TipBox', // 搜索落地页 - 右侧提示框
        RelatedPerson: 'RelatedPerson', // 搜索落地页 - 相关人员
    },
    // 空间域
    SpaceDepartment: {
        Entry: 'Entry', // 部门知识库 - 整体入口 （改版后是不是干掉了？）
        OrganizeIcon: 'OrganizeIcon', // 部门知识库 - 组织关系按钮
        ShareIcon: 'ShareIcon', // 部门知识库 - 分享按钮
        StatisticsTableColumns: 'StatisticsTableColumns', // 部门知识库 - 统计页 - 数据明细列表 - 知识库
        DepartmentHeadTabs: 'DepartmentHeadTabs', // 部门知识库 - 头部tab
        MyManageDepart: 'MyManageDepart', // 部门知识库 - 我管理的部门
        MyManageDepartTable: 'MyManageDepartTable', // 部门知识库 - 我管理的部门table
        NoticeNew: 'NoticeNew', // 部门知识库 - 全部公告
        DepartmentMessageServiceNumber: 'DepartmentMessageServiceNumber', // 部门知识库 - 发公告 - 发送至 - 部门消息服务号
        NoticeSendGroup: 'NoticeSendGroup', // 部门知识库 - 发公告 - 发送至 - 如流群复选框
        NoticeIsAite: 'NoticeIsAite', // 部门知识库 - 发公告 - 其他设置 - 消息发送到如流群内同时@全体成员+公告消息在如流群内置顶显示
        NotiveOtherSettingDoReadExample: 'NotiveOtherSettingDoReadExample', // 部门知识库 - 发公告 - 其他设置 - 示例按钮
        RecommendRepo: 'RecommendRepo', // 部门知识库- 首页 - 推荐知识库
        HonerWall: 'HonerWall', // 部门知识库- 首页 - 荣誉墙
        DataOverview: 'DataOverview', // 部门知识库- 首页 - 数据概览
        BaseOperationMore: 'BaseOperationMore', // 部门知识库- 知识库页 - 列表操作...
        SetNotice: 'SetNotice', // 部门公告-编辑公告
        NoticeType: 'NoticeType', // 部门编辑公告-公告类型
        CardPreview: 'CardPreview', // 部门公告-编辑公告右侧-消息卡片效果预览
        StatisticsOnlineDocRate: 'StatisticsOnlineDocRate', // 部门知识库 - 统计页 - 文档线上化率(图表视图)
        StatisticsPerCapita: 'StatisticsPerCapita', // 部门知识库 - 统计页 - 人均数据(图表视图)
        StatisticsPv: 'StatisticsPv', // 部门知识库 - 统计页 - 知识消费量(图表视图)
        StatisticsPvAverage: 'StatisticsPvAverage', // 部门知识库 - 统计页 - 人均知识消费量(图表视图)
    },
    SpaceRepo: {
        // Tree: 'Tree', // 空间域知识库详情 - 目录树。 目前只能对第一层目录的节点进行增加/替换/删除 （等待恒恒拆分重构中） - tree下掉了
        SidebarList: 'SidebarList', // 侧边栏首层目录
        HomeTagPage: 'HomeTagPage', // 标签管理页
        UnownedStatusTip: 'UnownedStatusTip', // 无主知识库提示
        UnownedStatusTipLink: 'UnownedStatusTipLink', // 无主知识库提示-查看如何申请管理员
        TreeCreateMenu: 'TreeCreateMenu', // 目录树的新建菜单
        ImportLocalFile: 'ImportLocalFile', // 头部新建-导入本地文件
        ExportContainer: 'ExportContainer', // 个人知识库 - 成员管理 - 导出知识库及页面的权限
        RecycleViewDialog: 'RecycleViewDialog', // 回收站 - 预览弹窗
        ConvertBookTypeMenu: 'ConvertBookTypeMenu', // 侧栏菜单转换 转换知识本类型
    },
    SpacePermission: {
        Content: 'Content', // 空间域权限申请页 - 申请选项
        ApplyAdminList: 'ApplyAdminList', // 权限申请页 - 管理员列表
        ShareRuliuButton: 'ShareRuliuButton', // 权限弹窗-分享到如流按钮
        AddPermissionCheckbox: 'AddPermissionCheckbox', // 分享到如流 - 为无权用户添加权限选项
        sendRuliuMessageCheckbox: 'sendRuliuMessageCheckbox', // 分享到如流 - 发送卡片至如流会话
    },
    SpaceDepartHome: {
        ShareIcon: 'ShareIcon', // 空间域团队知识库首页 - 分享按钮
        RemoveIcon: 'RemoveIcon', // 空间域团队知识库首页 - 移出(入)部门按钮
        MoreMenu: 'MoreMenu', // 团队知识库主页 - 更多菜单
        UpdateTableColumns: 'UpdateTableColumns', // 团队知识库主页 - 最近更新列表选项
    },
    SpacePersonalHome: {
        RuliuIcon: 'RuliuIcon', // 空间域个人知识库首页 - 如流按钮
        OrganizeIcon: 'OrganizeIcon', // 空间域个人知识库首页 - 组织架构按钮
        ShareIcon: 'ShareIcon', // 空间域个人知识库首页 - 分享按钮
        MoreMenu: 'MoreMenu', // 个人知识库主页 - 更多菜单
        Tag: 'Tag', // 个人知识库主页 - 标签
    },
    SpaceSetting: {
        SettingList: 'SettingList', // 设置列表
        PageSecurity: 'PageSecurity', // 设置 - 页面安全模块
        PageSecurityOptions: 'PageSecurityOptions', // 设置 - 页面安全选项
        AdvancedSetting: 'AdvancedSetting', // 设置 - 高级设置
    },
    SpaceKnowledgeHome: {
        RepositoryError: 'RepositoryError', // 因repositoryError出现错误页时的插槽
    },
    SpaceDocHome: {
        DocumentError: 'DocumentError', // 因DocumentError出现错误页时的插槽
    },
    // 文档域
    DocumentEditor: {
        Top: 'Top', // 文档编辑器 - 顶部插槽
        Bottom: 'Bottom', // 文档编辑器 - 底部插槽
        LikeButton: 'LikeButton', // 文档编辑器 - 点赞按钮
        BottomBar: 'BottomBar', // 文档编辑器 - 底部标签栏
        Tag: 'Tag', // 文档编辑器 - 底部的标签展示
        KnowledgeCoin: 'KnowledgeCoin', // 文档编辑器 - 送知识币按钮
        LikeAndCoinBtn: 'LikeAndCoinBtn', // 文档编辑器 - 点赞和知识币按钮按钮
        EditorTop: 'EditorTop', // 文档编辑器 - 在Editor组件上方
        Comment: 'Comment', // 文档编辑器 - 评论区
        Editor: 'Editor', // 文档编辑器 - rte组件区域
        pptEditor: 'pptEditor', // ppt - rte组件区域
        excelEditor: 'excelEditor', // excel - rte组件区域
        dataSheetEditor: 'dataSheetEditor', // 数据表 - rte组件区域
    },
    DocumentHeader: {
        StartMeetingButton: 'StartMeetingButton', // 文档操作栏 开始会议按钮
        EndMeetingButton: 'EndMeetingButton', // 文档操作栏 结束会议按钮
        EditButton: 'EditButton', // 文档操作栏 编辑按钮
        StarBtn: 'StarBtn', // 文档操作栏 星标按钮
        PublishButton: 'PublishButton', // 文档操作栏 更新按钮
        DemoModeButton: 'DemoModeButton', // 文档操作栏 演示按钮
        PermissionBtn: 'PermissionBtn', // 文档操作栏 - 权限按钮
        DocInfoRight: 'DocInfoRight', // 文档操作栏 - 文档信息右侧
        SquareGuide: 'SquareGuide', // 发布到广场按钮新手引导和弹窗
        pptPlayButton: 'pptPlayButton', // PPT - 播放按钮
        CancelEditButton: 'CancelEditButton', // 文档操作栏 退出编辑按钮
        MoreMenuIcon: 'MoreMenuIcon', // 文档操作栏 更多菜单图标
        ReadOnlyApplyButton: 'ReadOnlyApplyButton', // 文档操作栏 只读权限-权限申请按钮

        PreviewMoreMenu: 'PreviewMoreMenu', // 文档操作栏 预览模式-更多菜单
        EditMoreMenu: 'EditMoreMenu', // 文档操作栏 编辑模式-更多菜单
        pptMoreMenu: 'pptMoreMenu', // 文档操作栏 ppt-更多菜单
        excelMoreMenu: 'excelMoreMenu', // 文档操作栏 Excel-更多菜单
        // bookMoreMenu: 'bookMoreMenu', // 文档操作栏 知识本-更多菜单

        docMoreMenuFoldBtns: 'docMoreMenuFoldBtns', // 文档菜单-宽度变小折叠按钮
        pptMoreMenuFoldBtns: 'pptMoreMenuFoldBtns', // ppt菜单-宽度变小折叠按钮
        excelMoreMenuFoldBtns: 'excelMoreMenuFoldBtns', // 表格菜单-宽度变小折叠按钮
        dataSheetMoreMenuFoldBtns: 'dataSheetMoreMenuFoldBtns', // 数据表菜单-宽度变小折叠按钮
        bookMoreMenuFoldBtns: 'bookMoreMenuFoldBtns', // 知识本菜单-宽度变小折叠按钮
        ConvertBookTypeMenu: 'ConvertBookTypeMenu', // 更多菜单转换 转换知识本类型

    },
    Book: {
        CreateSheetButton: 'CreateSheetButton', // 知识本详情页 - 创建表格按钮
    },
    Help: {
        QuestionAnswer: 'QuestionAnswer', // 帮助 - 智能问答
    },
    ExternalRepo: {
        ExternalRepoTag: 'ExternalRepoTag', // 对外知识库的外部tag标签
    },
};

// test插槽默认文案
export const TextDefaultMap = {
    docCommentPlaceholder: '发表看法...',
    docPermissionApplyTip: '暂无该页面权限，您可以向以下用户申请权限',
    notPermissionViewVersion: '暂无该⻚面权限，需申请⻚面权限才可查看版本内容',
    applyDocPermissionText: '申请编辑权限',

    shareCollaboratePlaceholder: '可添加用户和如流群',
    addCollaboratePlaceholder: '搜索添加用户、如流群聊、邮件组', // 头部权限->打开添加成员页输入框的按钮(有添加权限)
    disAddCollaboratePlaceholder: '暂无权限添加用户、群和邮件组', // 头部权限->打开添加成员页输入框的按钮(无添加权限)
    shareCollaborateSearchDefault: '搜索用户、如流群和邮件组', // 头部权限->添加成员搜索框默认值
    convertToDirectoryToastEnd: '变更前文档如有正文，正文、评论与关联icafe信息将移入子文档。', // 顶栏更多->变更为知识本确认toast最后一行文案
    sendRuliuMessageTooltip: '邮件组和部门无法发送卡片', // 添加成员 - 发送卡片至如流会话Tooltip

    departmentHomeNotice: '通过如流服务号发送给全部部门成员', // 部门知识库->首页->发布公告
    departmentHomeNoticeFormTip: '公告详情页带水印且禁止复制', // 部门知识库->首页->发公告->其他设置->[设为保密公告]选项下的灰色提示语
    AnnounceToastContent: '此公告不会推送群及服务号消息，公告发布后可在部门公告列表查看', // 部门公告-发公告-发布-toast提示内容
    departmentNoticeDescription: '请输入摘要（摘要信息将会显示在公告列表/公告卡片上）', // 部门公告-发公告-公告摘要文案
    noticeDeleteToast: '删除后，此公告会从列表中移除且不可恢复（若公告已发送群或服务号消息，消息不会被撤回）', // 部门公告-删除-toast

    mentionCheckboxTip: '向@的人发送如流「单聊」通知', // 文档@人勾选框提示
    mentionCheckboxTip2: '发布后向@的人发送如流「单聊」通知',
    revokeRuliuMentionToast: '将发送如流通知至', // 文档@人toast文案
    sendNotifyAfterPublish: '发布后将发送如流通知至',
    revokeRuliuMentionToast2: '将发送如流「单聊」通知至', // 文档@人toast文案(单聊)
    sendNotifyAfterPublish2: '发布后将发送如流「单聊」通知至',
    revokeRuliuMentionSuccessTip: '撤销如流通知成功', // 文档@人toast撤销成功提示

    MyManageDepartMembersTip: '指 ERP 上部门的人数', // 我管理的部门成员数tip

    searchPageNoData: '未找到相关结果，换个搜索词试试', // 搜索落地页没有数据文案
};
